import { useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import styled from 'styled-components'

import Tab from './Tab'
import Card from './Card'
import Detail from './Detail'

import Colors from '../../../constants/Colors'
import { OBJ_BG_COLORS, TITLE_MENUS } from '../constants'

const OrderContent = ({
  status,
  orders,
  order,
  slips,
  remainingAmount,
  otherOrders,
  setSlips,
  setOrders,
  setOrder,
  setOtherOrders,
  setRemainingAmount,
  fetchOrdersByStatus,
  fetchOrderAferUpdateStatus,
}) => {
  const bgColor = OBJ_BG_COLORS[status]

  return (
    <>
      {!order ? (
        'ไม่มีข้อมูล'
      ) : (
        <Container bgColor={bgColor}>
          <Header lg>
            <Col sm="12" md="4" className="p-0">
              <H3>{TITLE_MENUS[status]}</H3>
            </Col>
            {/* {status === 'CONFIRMED' && (
              <CustomCol
                sm="12"
                md="8"
              >
                <Tab
                  tab={tab}
                  setTab={setTab}
                  fetchOrdersByStatus={fetchOrdersByStatus}
                  updateAllState={updateAllState}
                />
              </CustomCol>
            )} */}
          </Header>
          <Hr />
          <Content>
            <Card
              orders={orders}
              order={order}
              setSlips={setSlips}
              setOrders={setOrders}
              setOrder={setOrder}
              setOtherOrders={setOtherOrders}
              setRemainingAmount={setRemainingAmount}
            />
            <Detail
              status={status}
              order={order}
              slips={slips}
              remainingAmount={remainingAmount}
              otherOrders={otherOrders}
              setSlips={setSlips}
              setOrders={setOrders}
              setRemainingAmount={setRemainingAmount}
              fetchOrdersByStatus={fetchOrdersByStatus}
              fetchOrderAferUpdateStatus={fetchOrderAferUpdateStatus}
            />
          </Content>
        </Container>
      )}
    </>
  )
}

export default OrderContent

const Container = styled.div`
  width: 100%;
  height: auto;
  padding: 10px;
  border-radius: 20px;
  background-color: ${({ bgColor = Colors.ORANGE }) => bgColor};
`
const Header = styled(Row)`
  margin: 0;
`
const CustomCol = styled(Col)`
  padding: 0;
  display: flex;
  background-color: ${Colors.WHITE};
`
const H3 = styled.h3`
  height: 100%;
  display: flex;
  align-items: center;
  color: ${Colors.WHITE};
`
const Content = styled.div`
  display: grid;
  gap: 10px;
  grid-template-columns: minmax(0, 1fr) 2fr;
`
const Hr = styled.hr`
  margin-top: 10px;
  margin-bottom: 10px;
`
